import { Badge, type ButtonProps } from "@mantine/core";
import Link from "next/link";

import { UpsellPillProps } from "./types";
import { useStyles } from "./UpsellPill.styled";

type BaseProps = {
  cta: string;
} & Pick<ButtonProps, "type" | "disabled">;

const BaseUpsellPill = ({ type, disabled, cta }: BaseProps) => {
  const { classes } = useStyles();

  return (
    <Badge
      className={classes.upsellPill}
      component="button"
      type={type}
      disabled={disabled}
    >
      {cta}
    </Badge>
  );
};

export const UpsellPill = ({
  campaign,
  disabled,
  isSubmit,
  instanceId,
}: UpsellPillProps) => {
  if (isSubmit) {
    return (
      <BaseUpsellPill
        type="submit"
        disabled={!!disabled}
        cta="Start free Pro trial"
      />
    );
  }

  const href = {
    pathname: `/account/${instanceId}/plan`,
    query: {
      plan: "pro",
      utm_content: "store-instance",
      utm_campaign: campaign,
    },
  };

  return (
    <Link href={href}>
      <BaseUpsellPill cta="Upgrade to Pro" />
    </Link>
  );
};
